import { formatDateAndTimeZ, ia, stripHtmlTags } from 'lib/helpers/utility';

import {
  PATIENT_OPTIONS,
  PATIENT_PRACTICE_OPTIONS,
  PROVIDER_OPTIONS
} from 'components/shared/Filters/lib/filterOptions';

import OrdersActionsCellRenderer from '../Orders/components/OrdersActionsCellRenderer';

export const getDefaultFilters = ({ isAdmin, fromPatient }) => {
  return {
    type: {
      title: 'Type',
      placeholder: 'Search by type',
      allowed_operators: ['is', 'is not', 'is any of'],
      queryFn: (_, data) => {
        const searchTerm = data.filters.searchTerm || '';
        return {
          options: [
            isAdmin ? { label: 'eLab Order', value: 'elab_order' } : null,
            { label: 'Lab Order', value: 'lab_order' },
            { label: 'Referral Order', value: 'referral_order' },
            { label: 'Non ERX Prescription', value: 'non_erx_prescription' }
          ]
            .filter(Boolean)
            .filter((status) => status.label.toLowerCase().includes(searchTerm.toLowerCase()))
        };
      },
      queryKey: 'order_types.options',
      icon: 'status-mono'
    },
    ...(!fromPatient && {
      provider: { ...PROVIDER_OPTIONS, allowed_operators: ['is', 'is not', 'is any of'] }
    }),
    ...(fromPatient && {
      practice: {
        ...PATIENT_PRACTICE_OPTIONS,
        allowed_operators: ['is', 'is not', 'is any of']
      }
    }),
    ...(!fromPatient && {
      patient: { ...PATIENT_OPTIONS, allowed_operators: ['is', 'is not', 'is any of'] }
    }),
    order_date: {
      type: 'date-range',
      title: 'Order Date',
      icon: 'calendar-mono'
    },
    result_date: {
      type: 'date-range',
      title: 'Result Date',
      icon: 'calendar-1-mono'
    }
  };
};

export const GRID_OPTIONS = {
  rowGroupPanelShow: 'always',
  animateRows: true,
  suppressAggFuncInHeader: true,
  enableRangeSelection: true
};

export const getCols = ({
  fromPatient,
  openEditModal,
  openPreviewModal,
  openDeleteModal,
  openPreviewResult,
  timezone
}) =>
  [
    { field: 'type', headerName: 'Type', flex: 1, enableRowGroup: true },
    fromPatient
      ? {
          field: 'practice_name',
          headerName: 'Practice Name',
          flex: 1,
          enableRowGroup: true
        }
      : null,
    {
      field: 'provider_name',
      headerName: 'Provider Name',
      flex: 1,
      enableRowGroup: true
    },
    !fromPatient
      ? {
          field: 'patient_name',
          headerName: 'Patient Name',
          flex: 1,
          enableRowGroup: true
        }
      : null,
    {
      field: 'tests',
      headerName: 'Lab Name',
      flex: 1,
      enableRowGroup: true,
      valueFormatter: ({ value }) =>
        ia(value) ? [...new Set(value.map((test) => test.test_ref_lab))].join(', ') : '-'
    },
    {
      field: 'created_at',
      headerName: 'Order Date',
      flex: 1,
      valueFormatter: ({ value }) => (value ? formatDateAndTimeZ(value, timezone) : '-')
    },
    {
      field: 'result_date',
      headerName: 'Result Date',
      flex: 1,
      valueFormatter: ({ value }) => (value ? formatDateAndTimeZ(value, timezone) : '-')
    },
    {
      field: 'additional_info',
      headerName: 'Details',
      flex: 2,
      cellRenderer: ({ data, value }) => {
        if (!value || !data.rawType) return '-';

        if (data.rawType === 'non_erx_prescription') {
          return stripHtmlTags(value);
        } else if (data.rawType === 'referral_order') {
          return value;
        } else if (data.rawType === 'lab_order' || data.rawType === 'elab_order') {
          return ia(value) ? value.map((d) => d.label).join(', ') : '-';
        }
      }
    },
    {
      field: 'actions',
      headerName: 'Actions',
      cellRenderer: (props) => (
        <OrdersActionsCellRenderer
          data={props.data}
          fromPatient={fromPatient}
          openEditModal={openEditModal}
          openPreviewModal={openPreviewModal}
          openDeleteModal={openDeleteModal}
          openPreviewResult={openPreviewResult}
        />
      ),
      maxWidth: 88,
      minWidth: 36,
      resizable: false,
      sortable: false,
      pinned: 'right'
    }
  ].filter(Boolean);
